/**
 * predictive-search-locale-fix.js
 *
 * PROBLEM
 *   /<locale>/search/suggest returns HTTP 417 "Expectation failed: Unsupported
 *   buyer locale" on non-primary locales. Shopify's stock getSearchResults()
 *   calls this.close() on a non-ok response, so the search dropdown closes on
 *   every keystroke on Arabic pages.
 *
 *   Confirmed on kw, om and sa.mubkhar.com:
 *     /search/suggest?q=<arabic>      -> 200
 *     /ar/search/suggest?q=<arabic>   -> 417 Unsupported buyer locale
 *     /ar/search?q=<arabic>           -> 200
 *
 *   So this is NOT the Cloudflare WAF issue the old fix log described. The
 *   plain /search path is fine on localized URLs - only /search/suggest is not.
 *
 * FIX
 *   On localized paths only, fetch the same section from /<locale>/search
 *   instead of /<locale>/search/suggest. snippets/search-results.liquid renders
 *   from the `search` object when `predictive_search` is unavailable.
 *
 *   On the primary locale the native implementation is left completely alone.
 *
 * NO CREDENTIALS REQUIRED - unlike the older Storefront API approach, this needs
 * no token and the identical file works on every store.
 */

(function () {
  'use strict';

  function isLocalizedPath() {
    var root = (window.theme && theme.routes && theme.routes.home) || '/';
    return root !== '/' && root !== '';
  }

  function searchBase() {
    var base = (window.theme && theme.routes && theme.routes.search) || '/search';
    return base;
  }

  /**
   * AOS (Animate On Scroll) renders [data-aos] elements at opacity:0 and only
   * reveals them by adding .aos-animate when its observer sees them. AOS is
   * initialised once on page load, so markup injected afterwards never gets
   * that class - which is why Arabic product thumbnails rendered as empty
   * boxes while the English (native) path showed them fine.
   *
   * Verified 24 Aug 2026 on the Qatar draft: injected <image-element> had
   * class="" and opacity 0, whereas the English path had "aos-init aos-animate".
   */
  function revealAosElements(root) {
    if (!root) return;
    try {
      var nodes = root.querySelectorAll('[data-aos]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].classList.add('aos-init');
        nodes[i].classList.add('aos-animate');
      }
      if (window.AOS && typeof window.AOS.refreshHard === 'function') {
        window.AOS.refreshHard();
      }
    } catch (e) {
      /* non-fatal: results still render, just without the fade-in */
    }
  }

  customElements.whenDefined('predictive-search').then(function () {
    var Cls = customElements.get('predictive-search');
    if (!Cls || !Cls.prototype || typeof Cls.prototype.getSearchResults !== 'function') {
      return;
    }

    var native = Cls.prototype.getSearchResults;

    Cls.prototype.getSearchResults = function (searchTerm) {
      // Primary locale: nothing is broken, use Shopify's own implementation.
      if (!isLocalizedPath()) {
        return native.call(this, searchTerm);
      }

      var self = this;
      var url =
        searchBase() +
        '?q=' + encodeURIComponent(searchTerm) +
        '&section_id=search-results';

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (text) {
          var section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-search-results');

          if (!section) throw new Error('search-results section not found in response');

          self.predictiveSearchResults.innerHTML = section.innerHTML;
          revealAosElements(self.predictiveSearchResults);
          self.open();
        })
        .catch(function (err) {
          console.error('[predictive-search-locale-fix]', err);
          self.close();
        });
    };

    console.log('[predictive-search-locale-fix] active on localized paths');
  });
})();
